//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { RightsSkippedModalAction } from '@galleries/actions/rightsSkippedModalActions';
import { RIGHTS_SKIPPED_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IRightsSkippedModalState } from '@galleries/models/rightsSkippedModalModel';

const initialState: IRightsSkippedModalState = {
  isOpen: false,
};

export default function RightsSkippedModalReducer(
  state: IRightsSkippedModalState = initialState,
  action: RightsSkippedModalAction,
): IRightsSkippedModalState {
  switch (action.type) {
    case RIGHTS_SKIPPED_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case RIGHTS_SKIPPED_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
